(()=>{
  const money=(cents,currency)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100)}catch(e){return '$'+((Number(cents)||0)/100).toFixed(2)}};
  const qs=(s,r=document)=>r.querySelector(s), qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));

  function initQty(root=document){
    qsa('[data-mc-qty]',root).forEach(w=>{
      if(w.dataset.bound)return;w.dataset.bound='1';
      const form=w.closest('form'), input=qs('[data-main-quantity-input]',form), value=qs('[data-qty-value]',w);
      qsa('[data-qty-change]',w).forEach(btn=>btn.addEventListener('click',()=>{
        const n=Math.max(1,Math.min(99,Number(input?.value||1)+Number(btn.dataset.qtyChange||0)));
        if(input)input.value=n;if(value)value.textContent=n;
      }));
    });
  }

  function initBundles(root=document){
    qsa('[data-mc-bundle]',root).forEach(bundle=>{
      if(bundle.dataset.bound)return;bundle.dataset.bound='1';
      const productRoot=bundle.closest('[data-mc-product]')||bundle.closest('[data-product-root]');
      const currency=productRoot?.dataset.currency||'USD';
      const discount=Math.max(0,Math.min(100,Number(bundle.dataset.discount||0)));
      const addonInputs=qsa('[data-bundle-variant]',bundle);
      const recalc=()=>{
        const mainId=qs('form[data-ajax-product-form] [name="id"]',productRoot)?.value;
        let mainPrice=0;
        try{
          const variants=JSON.parse(qs('[data-product-variants]',productRoot)?.textContent||'[]');
          mainPrice=Number(variants.find(v=>String(v.id)===String(mainId))?.price||0);
        }catch(e){}
        const items=qsa('[data-bundle-item]',bundle);
        if(items[0])items[0].dataset.price=mainPrice;
        let original=mainPrice;
        addonInputs.forEach(input=>{
          let price=0;
          if(input.tagName==='SELECT')price=Number(input.options[input.selectedIndex]?.dataset.price||0);
          else price=Number(input.closest('[data-bundle-item]')?.dataset.price||0);
          const item=input.closest('[data-bundle-item]');
          if(item)item.dataset.price=price;
          const p=qs('[data-bundle-item-price]',item);if(p)p.textContent=money(price,currency);
          original+=price;
        });
        const total=Math.round(original*(100-discount)/100);
        const originalEl=qs('[data-bundle-original]',bundle),totalEl=qs('[data-bundle-total]',bundle);
        if(originalEl)originalEl.textContent=money(original,currency);
        if(totalEl)totalEl.textContent=money(total,currency);
      };
      addonInputs.forEach(i=>i.addEventListener('change',recalc));
      productRoot?.addEventListener('kalm:variant-change',recalc);
      recalc();

      qs('[data-bundle-add]',bundle)?.addEventListener('click',async e=>{
        const btn=e.currentTarget,old=btn.textContent;btn.disabled=true;btn.textContent='ADDING BUNDLE…';
        try{
          const mainId=Number(qs('form[data-ajax-product-form] [name="id"]',productRoot)?.value||0);
          const mainQty=1;
          const ids=addonInputs.map(i=>Number(i.value||0)).filter(Boolean);
          const items=[];
          if(mainId)items.push({id:mainId,quantity:mainQty,properties:{'_Bundle':'Device Bundle'}});
          ids.forEach(id=>items.push({id,quantity:1,properties:{'_Bundle':'Device Bundle'}}));
          if(items.length<2)throw new Error('Choose at least one add-on product for this bundle.');
          const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          if(!r.ok){const d=await r.json().catch(()=>({}));throw new Error(d.description||'Could not add bundle.');}
          const code=(bundle.dataset.discountCode||'').trim();
          if(code){location.href='/discount/'+encodeURIComponent(code)+'?redirect=/cart';return;}
          const opener=qs('[data-cart-open]');if(opener)opener.click();else location.href='/cart';
        }catch(err){alert(err.message||'Could not add bundle.');btn.disabled=false;btn.textContent=old;}
      });
    });
  }
  function init(root=document){initQty(root);initBundles(root)}
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
